import server from "../Server";
import withErrorCheck from "../CheckError";
import moment from "moment";
import { AddPlayerToGroupByEmailRequest } from "@grassrootly/api/entities";

export const AddPlayerToGroupByEmail = async (payload: AddPlayerToGroupByEmailRequest) => {
  const redirectTo = payload?.redirectTo ?? process.env.EXPO_PUBLIC_REST_PASSWORD_URL;

  // 1) Find or create player
  let player = null;
  let isNewPlayer = false;

  if (payload.email) {
    // If email provided, check if player exists
    let playerResp = await server.from("Players").select("*").eq("email", payload.email).limit(1);
    player = withErrorCheck(playerResp)?.[0] ?? null;
    isNewPlayer = !player;
  }

  if (!player) {
    // Create new player (with or without email)
    const playerData: any = {
      name: payload.name,
      created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
    };
    
    // Only add email if provided
    if (payload.email) {
      playerData.email = payload.email;
    }
    
    const insertResp = await server
      .from("Players")
      .insert(playerData)
      .select()
      .single();
    player = withErrorCheck(insertResp);
    isNewPlayer = true;
  }

  // 2) Guard: already in group?
  const memberCheckResp = await server
    .from("GroupPlayers")
    .select("*")
    .eq("group_id", payload.group_id)
    .eq("player_id", player.id)
    .limit(1);
  const existingMember = withErrorCheck(memberCheckResp)?.[0] ?? null;
  if (existingMember) throw new Error("Player is already a member of the group.");

  // 3) Insert membership
  const insertMemberResp = await server
    .from("GroupPlayers")
    .insert({
      group_id: payload.group_id,
      player_id: player.id,
      is_owner: false,
      created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
    })
    .select()
    .single();
  const groupMember = withErrorCheck(insertMemberResp);
  let sent_magic_link = false;
  if (isNewPlayer && payload.email) {
    const { error: otpErr } = await server.auth.signInWithOtp({
      email: payload.email,
      options: { emailRedirectTo: redirectTo },
    });
    if (otpErr) {
      await server.from("GroupPlayers").delete().eq("id", groupMember.id);
      await server.from("Players").delete().eq("id", player.id);
      throw otpErr;
    }
    sent_magic_link = true;
  }

  return {
    group_id: payload.group_id,
    player_id: player.id,
    joined_group: true,
    sent_magic_link,
  };
};
